import { render, staticRenderFns } from "./communityBbusiness.vue?vue&type=template&id=e753ed5e&scoped=true"
import script from "./communityBbusiness.vue?vue&type=script&lang=js"
export * from "./communityBbusiness.vue?vue&type=script&lang=js"
import style0 from "./communityBbusiness.vue?vue&type=style&index=0&id=e753ed5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e753ed5e",
  null
  
)

export default component.exports